import { useEffect, useState } from "react";

export type ViewMode = "desktop" | "mobile";

/** En dessous de cette largeur, la vue mobile (PWA) ; au-delà, la vue PC. */
const MOBILE_QUERY = "(max-width: 819px)";

/**
 * Vue mobile ou PC, choisie automatiquement selon la largeur de l'écran et
 * suivie en direct (rotation d'une tablette, fenêtre redimensionnée). Aucun
 * bouton : la même adresse bascule d'une vue à l'autre.
 */
export function useViewMode(): ViewMode {
  const [mobile, setMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const on = () => setMobile(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return mobile ? "mobile" : "desktop";
}
